// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3a570491","727":"0e7f1523"}[chunkId] + ".chunk.js";
};